var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"grey lighten-5 my-0 px-0 py-0",attrs:{"fluid":""}},[_c('q-my-leads-submenu'),_c('v-row',{staticClass:"mx-5"},[_c('v-col',{attrs:{"cols":"12"}},[_c('q-baseshop-lead-order-report-table',{attrs:{"title":"My Agency's Lead Orders","agent-code":_vm.user.Agent.AgentCode}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }